export default __webpack_public_path__ + "static/table-gradient-f77d646a0e7c54d94ef80f6cc83fd9c8.jpg";